module.exports = __webpack_public_path__ + "static/converter-bf70c4c9160adc064aa6da33bf9b4b07.png";